import Log from './partial/log'
const displayScore = (d) => {
  return (d.score < 0 ? '扣' : '加') + Math.abs(d.score) + '分'
}
export default {
  data() {
    return {
      data: {},
      modalVisible: false,
      reviewable:false,
    }
  },

  created() {

  },

  methods: {
    init(id , reviewable = false) {
      this.reset()

      this.id = id
      this.reviewable = reviewable
      this.modalVisible = true
      if (this.id) {
        this.query()
      }
    },

    reset() {
      this.data = {}
      this.id = null
    },
    query() {
      this.loading = true
      this.$request.licenseViolation(this.id).then(resp => {
        resp.data = this.$utils.conv(resp.data, { 'eventTime': 'datetime' , displayScore , 'state':'licenseViolationState'})
        this.data = resp.data || {}
        this.loading = false
      })
    },
    review(){
      this.$dialog({
        title: '审核',
        width: 550,
        paddingless: true,
        render: (h) => {
          return <Review record-id={this.id} />
        },
        onOk: () => {
          this.query()
        }
      })
    }
  },
  render() {
    const data = this.data || {}
    const company = data.company || {}
    const slots = data.examState == 0 && this.reviewable? {
      footer:() => {
        return <Button type="primary" on-click={this.review}>审核</Button>
      } 
    }:null

    const photos = data.photos ? data.photos.split(';') : []
    return <sl-side-panel scopedSlots={slots} v-model={this.modalVisible} loading={this.loading} mask-closable={false} title="查看违法信息" on-close={this.reset}>
      <Tabs value="t1">
        {
          this.$a('courier.list.detail.base') ? <TabPane label="基本信息" name="t1">
          <sl-detail-list col={1} labelAlign="right" labelWidth="100px" style="padding:12px;">
            <sl-detail-list-item title="快递员">{data.eventUserName}</sl-detail-list-item>
            <sl-detail-list-item title="证件号码">{data.eventUserIdcard}</sl-detail-list-item>
            {/*<sl-detail-list-item title="性别">{data.genderText}</sl-detail-list-item>*/}
            <sl-detail-list-item title="联系电话">{data.eventUserPhone}</sl-detail-list-item>
            <sl-detail-list-item title="所属企业">{data.companyName}</sl-detail-list-item>
            {/*<sl-detail-list-item title="政治面貌">{data.politicText}</sl-detail-list-item>*/}
            {/*<<sl-detail-list-item title="头像"><sl-img width="150px" public={true} src={data.imgPath} method="1" /></sl-detail-list-item>*/}
            <sl-detail-list-item title="违法时间">{data.eventTimeText}</sl-detail-list-item>
            <sl-detail-list-item title="违法地点">{data.eventAddress}</sl-detail-list-item>
            <sl-detail-list-item title="违法行为">{data.licenseRuleName}</sl-detail-list-item>
            <sl-detail-list-item title="违法车辆">No.{data.carNo}   {data.carLicenseNo}</sl-detail-list-item>
            <sl-detail-list-item title="违法处理">{data.displayScore}</sl-detail-list-item>
            <sl-detail-list-item title="违法状态">{data.stateText}</sl-detail-list-item>
            <sl-detail-list-item title="事件描述">{data.eventDesc}</sl-detail-list-item>
            <sl-detail-list-item title="图片">
              <sl-carousel images={data.eventImages ? data.eventImages.split(';') : []} /> 
            </sl-detail-list-item>
            
          </sl-detail-list>
        </TabPane> : null
        }

        {
          this.$a('license.violation.record') ? <TabPane label="操作记录" value="t2">
            <Log logs={data.actLogs} />
          </TabPane>:null 
        }
        
      </Tabs>
    </sl-side-panel>
  }
}
